import { Component, Input, OnInit } from '@angular/core';
import { Order } from 'src/app/intefaces/order';
import { ArrangerService } from 'src/app/services/arranger.service';
import { BrowserStorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-profits',
  templateUrl: './profits.component.html',
  styleUrls: ['./profits.component.scss']
})
export class ProfitsComponent implements OnInit {

  constructor(private arrangerService: ArrangerService, private browserStorageService: BrowserStorageService) { }
  public orders: Order[] = [];
  public totalCount: any;
  public isDataReady:boolean = false;
  public limit = 0;
  @Input() userId = null;
  public isAdmin: boolean = (this.browserStorageService.get("_role") == "admin") ? true : false;

  public model = {
    userId: this.userId,
    page: 0,
    dateFrom: null,
    dateTo: null,
    status: null,
    isPaid: true
  };
 
  ngOnInit(): void {
    this.model = {
      userId: this.userId,
      page: 0,
      dateFrom: null,
      dateTo: null,
      status: null,
      isPaid: true
    };

    this.getProfit();

  }

  private fixDate(d) {    
    let date: Date = d;
    return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));  
  }

  private getProfit(page = 0) {
    this.model.page = page;
    if(this.model.dateFrom != null) {
      this.model.dateFrom  = this.fixDate(this.model.dateFrom);
    }

    if(this.model.dateTo != null) {
      this.model.dateTo  = this.fixDate(this.model.dateTo);
    }

    this.arrangerService.getProfit(this.model).subscribe(result => {
      this.orders = result.data;
      this.totalCount = result.message.totalCount;
      this.isDataReady = true;
      this.limit = result.message.limit;
    });
  }

  public onPaginate(ev) {
    this.getProfit(ev.page);
  }

  onFilter() {
    this.getProfit();
  }

}
